export const routes = {
  blog: '/blog',
  events: '/events',
  eventRsvpConfirmation: '/event-rsvp-confirmation',
}
